import getGraphQLClient from '../../GraphQL/graphQLClient';
import MegaScreenerPartialSiteSettingsByTAQuery, {
  getMegaScreenerPartialSiteSettingsByTAQueryParameters,
  mapPartialSiteSettingsResults,
  MegaScreenerPartialSiteSettingsItem,
} from '../../GraphQL/queries/megaScreenerPartialSiteSettings.query';

const DEFAULT_LANGUAGE = 'en';

const fetchPartialSiteSettings = async (
  language: string
): Promise<MegaScreenerPartialSiteSettingsItem[]> => {
  const graphQLClient = getGraphQLClient();

  const response = await graphQLClient.request<any>(
    MegaScreenerPartialSiteSettingsByTAQuery as any,
    getMegaScreenerPartialSiteSettingsByTAQueryParameters(language)
  );

  return mapPartialSiteSettingsResults(response?.search?.results ?? []);
};

/** Falls back to `en` when the requested language has no partial site settings versions. */
export const fetchPartialSiteSettingsWithLanguageFallback = async (
  language: string
): Promise<MegaScreenerPartialSiteSettingsItem[]> => {
  const requestedLanguage = language || DEFAULT_LANGUAGE;
  const partialSiteSettings = await fetchPartialSiteSettings(requestedLanguage);
  if (partialSiteSettings.length) {
    return partialSiteSettings;
  }

  return [];
};
